import React from 'react';
import Plot from 'react-plotly.js';
import * as Const from '../../../utils/Const';

interface TrainingSceneEndCountProps {
  data?: any; // 引数として渡すプロパティ
}

export const TrainingSceneEndCount: React.FC<TrainingSceneEndCountProps> = ({ data }) => {
  const dataList = data || '';

  const graphData: any[] = [
    {
      type: 'table',
      header: {
        // values: [['回答者数']],
        line: { width: 0, color: `${Const.BackGroundMainColor}` },
      },
      cells: {
        values: [[dataList + '件']],
        line: { width: 0, color: 'none' },
        fill: {
          color: `${Const.BackGroundMainColor}`,
        },
        font: {
          size: 100,
          color: ['black'],
        },
        align: 'center',
      },
    },
  ];

  if (dataList === '') return <></>;

  return (
    <>
      <details className="rounded-3xl shadow-custom-lg overflow-hidden bg-white ml-2 mr-4 mt-2 mb-8">
        <summary className="cursor-pointer px-4 py-3 text-4xl">回答者数</summary>
        <Plot
          data={graphData}
          layout={{
            title: {
              text: '', // タイトルのテキスト
              font: { size: 0 }, // タイトルのフォントサイズ
            },
            // height: 450,
            margin: {
              t: 100, // 上部のマージンを確保
              l: 0,
              r: 0,
              b: 15,
            },
            autosize: true,
          }}
          config={{
            responsive: true, // レスポンシブデザインを有効にする
            displayModeBar: false, // モードバーを非表示にする
            displaylogo: false, // Plotlyロゴを非表示にする
            staticPlot: true, // プロットを静的にする
          }}
          style={{ width: '100%', height: '100%', minHeight: '450px' }}
        />
      </details>
    </>
  );
};
